import { useState } from "react";
import Step1 from "../Components/Create/Step1";
import { toast } from "react-toastify";
import { Button, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "react-feather";
import UploadManually from "../Components/Create/Step2/UploadManually";
import { uploadFileToBucket } from "../Utils";
import { API_URL } from "../Config/secrets";
import axios from "axios";
import UploadFile from "../Components/Create/Step2/UploadFile.jsx";

const arrayFields = ['wholesale_group', "market", "age", "product_category", "target_group", "price", "style", "preferred_market"];

const CreatePage = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [tab, setTab] = useState('1');
  const [name, setName] = useState('');
  const [logo, setLogo] = useState(null);
  const [theme, setTheme] = useState('');

  const steps = [
    { id: 1, label: 'Step 1' },
    { id: 2, label: 'Step 2' },
  ];

  const handleNext = () => {
    if (currentStep === 1 && (!name || !theme)) return toast.info('Fill all details')

    if (currentStep < steps.length) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const onSubmit = async (data) => {
    try {
      const logo_url = logo ? await uploadFileToBucket("/company-logos", logo) : null;

      const uploadLogos = async (items, folder) => {
        return Promise.all(items.map(async (item) => {
          let newItem = { ...item };

          arrayFields.forEach((c) => {
            newItem[c] = item[c]?.map((c) => c?.label) || [];
            console.log(newItem[c], item[c])
          })

          if (item.logo) {
            const uploadedLogo = await uploadFileToBucket(`/${folder}`, item.logo);
            newItem.logo = uploadedLogo;
          }

          return newItem;
        }));
      };

      const brands = await uploadLogos(data?.brands || [], 'brands-logos');
      const wholesalers = await uploadLogos(data?.wholesalers || [], 'wholesalers-logos');
      const retailers = await uploadLogos(data?.retailers || [], 'retailers-logos');

      const response = await axios.post(`${API_URL}/company/create`, {
        name,
        logo: logo_url,
        theme,
        brands,
        wholesalers,
        retailers
      });
      console.log('RESPON', response)

      if (response?.data?.statusCode === 200) {
        window.open(`http://208.110.93.73:3001/${response?.data?.data?.name}/login`, '_blank')
        navigate('/home')
        toast.success(response?.data?.message);
      }
    } catch (e) {
      console.log('e', e)
      toast.error(e?.response?.data?.message || 'Something went wrong');
    }
  };

  const onSubmitWithFileUpload = async (payload) => {
    try {
      const logo_url = logo ? await uploadFileToBucket("/company-logos", logo) : null;

      const createAPIResponse = await axios.post(`${API_URL}/company/create`, {
        name,
        logo: logo_url,
        theme,
      });

      const companyId = createAPIResponse?.data?.data?.id;

      if (!companyId) return;

      const response = await axios.post(`${API_URL}/company/upload-bulk-data`, { ...payload, companyId: Number(companyId) });
      console.log(response?.data?.data)

      if (response?.data?.statusCode === 200) {
        window.open(`http://208.110.93.73:3001/${response?.data?.data?.name}/login`, '_blank')
        navigate('/home')
        toast.success(response?.data?.message);
      }

      return response?.data;
    } catch (e) {
      toast.error(e?.message || 'Something went wrong');
    }
  };

  return (
    <div className="container">
      <div>
        <Button onClick={() => navigate(-1)} color="primary"><ChevronLeft size={18} /> Home</Button>
      </div>
      <div className="w-75 mx-auto">
        <div className="d-flex justify-content-between position-relative mb-4">
          <div
            className="w-100 position-absolute top-5 translate-middle-y border-top"
            style={{ zIndex: 0 }}
          ></div>
          {steps.map((step) => (
            <div
              key={step.id}
              className="position-relative text-center"
              style={{ zIndex: 1, width: '25%' }}
            >
              <div
                className={`rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center
            ${currentStep >= step.id ? 'bg-primary text-white' : 'bg-light text-muted'}`}
                style={{ width: 50, height: 50, border: '2px solid #dee2e6' }}
              >
                {step.id}
              </div>
              <div className={currentStep >= step.id ? 'fw-bold text-primary' : 'text-muted'}>
                {step.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {currentStep === 1 && <Step1 name={name} setName={setName} logo={logo} setLogo={setLogo} theme={theme} setTheme={setTheme} handleNext={handleNext} />}
      {currentStep === 2 && (
        <div className="container mt-4" style={{ maxWidth: '800px', margin: '0px auto' }}>
          <h2 className="mb-4">Upload Data</h2>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={`${tab === '1' ? 'active' : ''}`}
                style={{ cursor: 'pointer' }}
                onClick={() => setTab('1')}
              >
                Maunual
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`${tab === '2' ? 'active' : ''}`}
                style={{ cursor: 'pointer' }}
                onClick={() => setTab('2')}
              >
                File
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={tab}>
            <TabPane tabId="1">
              <UploadManually onSubmit={onSubmit} />
            </TabPane>
            <TabPane tabId="2">
              <UploadFile onSubmit={onSubmitWithFileUpload} />
            </TabPane>
          </TabContent>
        </div>
      )}
    </div>
  );
};

export default CreatePage;
